import { makeCanvas } from "./makeCanvas";

/**
 * Draws offscreen canvas on HTMLCanvasElement and returns it. If instance of HTMLCanvasElement was passed, simple
 * returns it.
 *
 * @param canvas
 */
export function toHTMLCanvasElement(
  canvas: OffscreenCanvas | HTMLCanvasElement
): HTMLCanvasElement {
  if (canvas instanceof HTMLCanvasElement) {
    return canvas;
  }
  const canvasElement = makeCanvas(canvas.width, canvas.height, true);
  const context = canvasElement.getContext("2d");
  if (!context) {
    throw new Error("Couldn't get canvas context");
  }
  context.drawImage(canvas, 0, 0);
  return canvasElement;
}
